<template>
    <div>
        <item-title title="自选餐"></item-title>
        <div class="wrap">
            <div ref="content" class="unified-meal" :style="`animation-duration:${animationDuration}s`">
                <table>
                    <thead>
                        <tr>
                            <th>星期</th>
                            <th>早餐</th>
                            <th>中餐</th>
                            <th>晚餐</th>
                        </tr>
                    </thead>
                    <tbody v-for="(item, index) in infos" :key="index">
                        <tr>
                            <td colspan="4">
                                <div class="gradient-line"></div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div class="week">{{ item.endDate }}</div>
                                <div class="date">{{ item.startDate }}</div>
                            </td>
                            <td>
                                <span v-if="!item.breakfastList || item.breakfastList.length===0">无</span>
                                <div v-for="(foodItem, foodIndex) in item.breakfastList" :key="foodIndex">
                                    <span>{{ foodItem.name }}</span>
                                    <span>{{ foodItem.price }}元</span>
                                </div>
                            </td>
                            <td>
                                <span v-if="!item.lunchList || item.lunchList.length===0">无</span>
                                <div v-for="(foodItem, foodIndex) in item.lunchList" :key="foodIndex">
                                    <span>{{ foodItem.name }}</span>
                                    <span>{{ foodItem.price }}元</span>
                                </div>
                            </td>
                            <td>
                                <span v-if="!item.dinnerList || item.dinnerList.length===0">无</span>
                                <div v-for="(foodItem, foodIndex) in item.dinnerList" :key="foodIndex">
                                    <span>{{ foodItem.name }}</span>
                                    <span>{{ foodItem.price }}元</span>
                                </div>
                            </td>
                            <div class="gradient-line"></div>
                        </tr>
                    </tbody>
                </table>
                <div class="tip">
                    <div v-html="msg"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import itemTitle from '@/components/itemTitle'; // 标题 

    export default {
        components: {
            itemTitle
        },
        props: {
            deptId: {
                type: String,
                default: ''
            },
            outletsId: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                msg: '',
                infos: [], // 自选餐
                animationDuration: 0
            }
        },
        computed: {
            // animationDuration() {
            //     if (this.infos.length >= 6) {
            //         return (this.infos.length + 2) * 2.5
            //     }
            //     return 0
            // }
        },
        mounted() {
            this.getMenuPriceAnnouncement()
            this.getMenuPriceAnnouncementList()
        },
        methods: {
            getMenuPriceAnnouncement() {
                const param = {
                    canteenId: this.deptId,
                    outletsId: this.outletsId,
                    recipeType: 1
                }
                this.$get(this.$api.getMenuPriceAnnouncement, param).then(res => {
                    this.msg = res.data.optionRemark.replace(/\n/g, '<br />')
                })
            },
            // 获取餐次信息
            getMenuPriceAnnouncementList() {
                const param = {
                    outletsId: this.outletsId,
                    recipeType: 1
                }
                this.$get(this.$api.getMenuPriceAnnouncementList, param).then(res => {
                    this.infos = res.data
                    this.$nextTick(() => {
                        this.calcDocumentHeight()
                    })
                })
            },
            // 计算高度
            calcDocumentHeight() {
                if (this.$refs.content.offsetHeight > 900) {
                    this.animationDuration = (this.$refs.content.offsetHeight / 200) * 2.5
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @keyframes scroll-up {
        0% {
            transform: translateY(0);
            /* 文本初始位置，向上偏移 0 */
        }

        100% {
            transform: translateY(-100%);
            /* 文本最终位置，向上偏移 100%（等于滚动区域高度） */
        }
    }

    .wrap {
        height: vh(766);
        width: 100%;
        overflow: hidden;
    }

    .unified-meal {
        display: flex;
        flex-direction: column;
        min-height: 100%;
        width: 100%;
        animation-name: scroll-up;
        animation-duration: 0;
        animation-timing-function: linear;
        animation-iteration-count: infinite;

        table {
            @include font(18, #ffffff, center);
            width: 100%;
            border-collapse: collapse;

            thead {
                th {
                    padding: vh(15) 0;
                    @include font(26, #FFF, center);
                }
            }

            tbody {
                text-align: center;

                tr {

                    td {
                        @include font(24, #FFF, center);
                        padding: vh(10) 0;

                        &>div {
                            width: 100%;
                            display: flex;
                            align-items: center;

                            span {
                                &:first-child {
                                    width: vh(100);
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    white-space: nowrap;
                                }

                                &:last-child {
                                    @include font(18, #1DB7FF, center);
                                }
                            }
                        }

                        .week {
                            padding: 0 vh(20);
                            justify-content: center;
                            @include font(28, #1DB7FF, center);
                        }

                        .date {
                            padding: 0 vh(20);
                            @include font(24, #FFF, center);
                            justify-content: center;
                        }

                        div+div {
                            margin-top: 5px;
                        }
                    }

                    .gradient-line {
                        width: 100%;
                        height: 3px;
                        /* 或您需要的边框高度 */
                        background: linear-gradient(90deg, #00048F, #0066B4, #00048F);
                    }
                }
            }
        }

        .tip {
            margin-top: auto;
            background: #000256;
            padding: vh(20) 0 vh(20) vh(40);
            @include font(18, #ffffff, left);

            p {
                line-height: 1.5;
            }
        }
    }
</style>